<template>
  <div class="card">
    <!--    <td class="text-right">-->
    <!--      <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm   btn-neutral  ">-->
    <!--        <i class="fa fa-user"></i>-->
    <!--      </button>-->
    <!--      <button type="button" rel="tooltip" class="btn btn-success btn-icon btn-sm   btn-neutral  ">-->
    <!--        <i class="fa fa-edit"></i>-->
    <!--      </button>-->
    <!--      <button type="button" rel="tooltip" class="btn btn-danger btn-icon btn-sm   btn-neutral  ">-->
    <!--        <i class="fa fa-times"></i>-->
    <!--      </button>-->
    <!--    </td>-->
    <div class="card-body hm400">
      <h5 class="card-title text-center font-weight-bold">Recent Ticket Comments</h5>
      <div>
        <span class="font-weight-bold">Filter By:</span>
        <span v-for="(row, index) in filters" :key="index" class="font-weight-bold badge p-2 ml-15 make-cursor-pointer" :class="selectedFilter.key === row.key ? 'badge-pill badge-success' : 'badge-pill badge-light'" @click="selectedFilter.key = row.key; getRecentTickets(row.key, row)">
        {{row.displayName}}
      </span>
      </div>
      <div class="table-responsive mt-10">
        <div class="" v-if="loading && !autoLoading">
          <!-- Show the loader when async operation is going on -->
          <div class="loader"></div>
        </div>
        <perfect-scrollbar class="scroll-area-modal" v-else >
          <table  class="table table-striped single-outage-table">
            <thead>
            <tr>
              <th class='text-left'>Admin</th>
              <th class="text-center">Ticket Title</th>
              <th>Ticket Category</th>
              <th>Last Reply</th>
              <th>Ticket Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr :class="lastReply(value)" v-for="value in recentTicketCommentList" :key="value.uid">
              <td class="d-flex justify-content-between  align-items-center">
                <div v-if="getTag(value.tags)">
                  <img data-toggle="tooltip" data-placement="top" data-html="true" class="rounded-circle" :title="getTag(value.tags)" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(value.email)}?s=50`">
                </div>
              </td>
              <td>
                {{ value.tsubject }}
              </td>
              <td >{{value.deptname}}</td>
              <td>{{value.lastreply}}</td>
              <td>{{value.status}}</td>
              <td class="text-center">
                <button @click="openTicket(value.ticket_number)" title="View Ticket" type="button" rel="tooltip" class="btn btn-outline-info btn-icon btn-sm ">
                  <i class="fa fa-eye"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </perfect-scrollbar >
        <div v-if="recentTicketCommentList && recentTicketCommentList.length === 0 && !loading">  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from "crypto-js/md5";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import {db, messaging} from "@/firebase/init";

export default {
  name: "RecentTicketComments",
  mounted(){
    this.getRecentTickets('myTickets', {data: {tags: ''}})
    this.onMessageListener();
  },
  components: {
    PerfectScrollbar
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },

  },
  methods: {
    lastReply(value){
      let numbers = value.lastreply.split(' ');
      if(Number(numbers[0]) < 10 && (numbers[1] === 'minutes' || numbers[1] === 'seconds') && value.status !=="Answered") {
        return 'font-weight-bold'
      }
      return ''
    },
    onMessageListener() {
      messaging.onMessage((data) => {
        console.log('payload received', data)
        if(data.data.title === 'Recent comment'){
          this.autoLoading = true;
          this.getRecentTickets('myTickets', {data: {tags: ''}})
        }
      })
    },
    getTag(tags) {
      return tags && Array.isArray(tags) && tags.length > 0 ? `<span class=text-capitalize>${tags[0].tag}</span>`: ''
    },
    openTicket(ticketNo) {
      window.open(`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&num=${ticketNo}`, '_blank')
    },
    emailHashGravatar(email) {
      console.log('email', email)
      if (!email || email === null) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    async getRecentTickets(type, row) {
      try {
        console.log('ser', this.user)
        this.loading = true;
        this.recentTicketCommentList = []
        if (type === 'myTickets') {
          const ref = await db.collection('users').doc(this.user.uid).get();
          if (ref.exists) {
            row.data.tags = ref.data().hbTags ? ref.data().hbTags.join(', ') : '' || '';
          }
        }

        const response = await this.$http.post('/host-bill/all_tickets', {
          grant_type: 'token',
          type,
          perpage: this.perpage,
          ...row.data
        })
        if (response.data.success) {
          this.recentTicketCommentList = response.data.tickets
        }
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        console.log('response', response)
      } catch (e) {

      } finally {
        console.log('recent ticket', this.recentTicketCommentList)
        this.loading = false
        this.autoLoading = false;
      }
    }
  },
  data () {
    return {
      autoLoading: false,
      loading: false,
      selectedFilter: { key: 'myTickets'},
      filters: [
        { key: 'allTickets', displayName: 'All Tickets', data: {} },
        { key: 'myTickets', displayName: 'My Tickets', data: { tags: this.user && this.user.hbTags && this.user.hbTags.length > 0 ? this.user.hbTags.join(', ') : '' }},
        { key: 'support', displayName: 'Support', data: { dept: 2 } },
        { key: 'billing', displayName: 'Billing', data: { dept: 4 } },
      ],
      perpage: 20,
      recentTicketCommentList: []
    }
  }
}
</script>
<style scoped>
.scroll-area {
  position: relative;
  max-height: 300px;
  /*overflow: hidden;*/
}
.scroll-area-modal {
  position: relative;
  max-height: 300px;
  overflow: hidden;
}
th{
  font-weight: bold !important;
}
</style>
